module.exports = __webpack_public_path__ + "static/media/placeholder.user.0ed9e19d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placeholder.user.png
// module id = 667
// module chunks = 0